import {
  Image,
  Logo,
  ProductDetail,
  TSubscriptionLevel,
  Tag,
} from '@nettbureau/featured-core';
import { Card } from '@nettbureau/vibrant-ui';
import { CardBackground } from './CardBackground';
import { FeaturedCard } from './FeaturedCard';
import { ProductDetails } from './ProductDetails';

export function ProductCard({
  id,
  title,
  tags,
  bodyLine1,
  bodyLine2,
  icon,
  background,
  center,
  logo,
  subscriptionLevel,
  minHeight,
  isCardSelected,
  internalLink,
}: ProductCardProps) {
  return (
    <FeaturedCard minHeight={minHeight} isCardSelected={isCardSelected}>
      <CardBackground
        id={id}
        icon={icon ?? null}
        center={center ?? null}
        logo={subscriptionLevel === 'premium' && logo ? logo : null}
        background={background}
      />

      <Card.Body css={{ paddingTop: 0 }}>
        <ProductDetails
          title={title}
          tags={tags}
          href={internalLink ?? ''}
          bodyLine2={bodyLine2}
          bodyLine1={bodyLine1}
        />
      </Card.Body>
    </FeaturedCard>
  );
}

interface ProductCardProps {
  /** Determines the minimum height of the card. */
  minHeight?: number;
  /** Determines the subscription level of the company. */
  subscriptionLevel: TSubscriptionLevel;
  /** ProductCard id prop. */
  id?: number;
  /** ProductCard title prop. */
  title: string;
  /** ProductCard subtitle prop. */
  subTitle: string | null;
  /** ProductCard tags prop. */
  tags?: Tag[] | null;
  /** ProductCard bodyline1 prop. */
  bodyLine1: string | null;
  /** ProductCard bodyline2 prop. */
  bodyLine2: ProductDetail[] | null;
  /** ProductCard phone number action. */
  phone?: string;
  /** ProductCard email action. */
  email?: string;
  /** ProductCard website action. */
  website?: string;
  /** Center image URL. */
  center: Image | null;
  /** Icon URL. */
  icon: Image | null;
  /** Logo */
  logo: Logo['logo'];
  /** Is ProductCard Selected. */
  isCardSelected?: boolean;
  /** Link to page. */
  href?: string;
  /** Background URL. */
  background: Image | Image[] | null;
  /** Internal link. */
  internalLink: string | null;
}
